import { c as _c } from "react/compiler-runtime";
import { useLocalStorageValue } from '@react-hookz/web/useLocalStorageValue/index.js';
import { Banner } from '#components/Banner/Banner';
import { useEnvironment } from '#cutils/context/EnvironmentContext';
import { isIe } from '#cutils/misc/isIe';
type Props = {
  className?: string;
};
export function BannerOutdatedBrowserContainer(t0) {
  const $ = _c(7);
  const {
    className
  } = t0;
  const {
    localStorageKeys
  } = useEnvironment();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      defaultValue: false
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    value: warningIsConfirmed,
    set: setWarningIsConfirmed
  } = useLocalStorageValue(localStorageKeys.LOCAL_STORAGE_KEY_OUTDATED_BROWSER, t1);
  let t2;
  if ($[1] !== setWarningIsConfirmed) {
    t2 = function handleClose() {
      setWarningIsConfirmed(true);
    };
    $[1] = setWarningIsConfirmed;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClose = t2;
  if (isIe() && !warningIsConfirmed) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <p>Hinweis: Um alle Funktionen unserer Seiten nutzen zu können, verwenden Sie bitte einen neueren Browser (z.B. die aktuellen Versionen von Chrome, Edge, Firefox oder Safari).</p>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    if ($[4] !== className || $[5] !== handleClose) {
      t4 = <Banner className={className} onClose={handleClose}>{t3}</Banner>;
      $[4] = className;
      $[5] = handleClose;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  } else {
    return null;
  }
}